// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 763 ? "7795b455" : chunkId) + "-" + {"759":"c975bcf2927c716e","763":"e98b344b09c5b417","896":"e879ca093841bb74"}[chunkId] + ".js";
};